module.exports = __webpack_public_path__ + "media/video.a29ce06d.mp4";